<ng-container [ngSwitch]="provider">
    <lib-gmap-search-movisat *ngSwitchCase="'Google'" [lang]="lang" [texts]="texts" [searchBounds]="searchBounds"
        [searchCountry]="searchCountry" (mapSearch)="onMapSearch($event)">
    </lib-gmap-search-movisat>
    <lib-hmap-search-movisat *ngSwitchCase="'Here'" [lang]="lang" [texts]="texts" [searchBounds]="searchBounds"
        [searchCountry]="searchCountry" (mapSearch)="onMapSearch($event)">
    </lib-hmap-search-movisat>
    <div *ngSwitchDefault>
        <b>Proveedor de cartografía no soportado!</b>
    </div>
</ng-container>